import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type {
  CreateEnvelopeRequest,
  CreateEnvelopeResponse,
} from './create-envelope.types'

const createEnvelope = async (
  payload: CreateEnvelopeRequest,
): Promise<CreateEnvelopeResponse> => {
  const response = await apiClient.post<CreateEnvelopeResponse>(
    '/v1/ecm/envelopes',
    payload,
  )
  return response.data
}

export const useCreateEnvelope = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (payload: CreateEnvelopeRequest) => createEnvelope(payload),
    meta: {
      invalidatesQuery: 'envelopes',
      ...feedback,
    },
  })
}
